import { isoZ, z } from 'my-zod'
import {
  BusinessTypeEnum,
  ExpectedImpactEnum,
  CompetitiveRentalAssetsEnum,
  ProspectSourceEnum,
  TypeOfExperienceEnum,
  VehicleTypeEnum
} from '../../outfitter-account-management/outfitter'
import { TimeZoneEnum } from '../../internal'

function makeAdHocFormSubmissionType<T extends string, Shape extends z.ZodRawShape>(type: T, shape: Shape) {
  return z.object({
    id: z.string().uuid(),
    type: z.literal(type),
    content: z.object(shape),
    createdDate: isoZ.instant()
  })
}

const newsletterSignup = makeAdHocFormSubmissionType('newsletterSignup', {
  email: z.string().min(1)
})

export const OutfitterApplicationEnums = {
  directTrailAccessOptions: ['Yes', 'No', 'Unsure'] as const,
  trailDifficultyOptions: ['Beginner', 'Advanced', 'Both'] as const
}

const outfitterApplication = makeAdHocFormSubmissionType('outfitterApplication', {
  company: z.string().min(1),
  website: z.string().optional(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().min(1).email(),
  phone: z.string().optional(),
  city: z.string().min(1),
  state: z.string().min(1),
  addressLine1: z.string().min(1),
  addressLine2: z.string().nullable().optional(),
  postalCode: z.string().min(1),
  howDidYouHearAboutUs: ProspectSourceEnum,
  howDidYouHearAboutUsExplanation: z.string().optional(),
  businessType: BusinessTypeEnum,
  aboutTheBusiness: z.string().min(1),
  expectedImpact: ExpectedImpactEnum,
  vehicleTypes: VehicleTypeEnum.array().min(1),
  directTrailAccess: z.enum(OutfitterApplicationEnums.directTrailAccessOptions).optional(),
  trailDifficulty: z.enum(OutfitterApplicationEnums.trailDifficultyOptions).optional(),
  typeOfExperience: TypeOfExperienceEnum.optional(),
  bodyOfWater: z.string().optional(),
  numberOfVehicles: z.string().min(1),
  competitiveRentalAssets: CompetitiveRentalAssetsEnum.array().refine((data) => data.length > 0, 'Required'),
  yearRoundSeason: z.number().optional(),
  timezone: TimeZoneEnum.nullable().optional()
})

export const adHocFormSubmission = z.discriminatedUnion('type', [newsletterSignup, outfitterApplication])
export type adHocFormSubmission = z.infer<typeof adHocFormSubmission>

export type adHocFormSubmissionType = adHocFormSubmission['type']
export type adHocFormSubmissionGeneric<T extends adHocFormSubmissionType> = Extract<adHocFormSubmission, { type: T }>
